.credit-card-payment-message {
  font-size: 12px;
  color: var(--default--text-color--2);
  margin-top: 8px;
}
